import { render } from "./Topic.vue?vue&type=template&id=303f3bad&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"

import "./Topic.vue?vue&type=style&index=0&id=303f3bad&scoped=true&lang=scss"
import "./Topic.vue?vue&type=style&index=1&id=303f3bad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303f3bad"]])

export default __exports__